// import 'promise-polyfill/src/polyfill'

// forEach pollyfill
(function () {
  if (typeof NodeList.prototype.forEach === 'function') {
    return false
  }

  NodeList.prototype.forEach = Array.prototype.forEach
})();

// node.remove() pollyfill
(function () {
  let arr = [window.Element, window.CharacterData, window.DocumentType]
  let args = []

  arr.forEach(function (item) {
    if (item) {
      args.push(item.prototype)
    }
  });

  // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md

  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return false
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove () {
          this.parentNode.removeChild(this)
        }
      })
    })
  })(args)
})();

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('append')) {
      return
    }
    Object.defineProperty(item, 'append', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append () {
        var argArr = Array.prototype.slice.call(arguments)
        var docFrag = document.createDocumentFragment()

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)))
        })

        this.appendChild(docFrag)
      }
    })
  })
})([Element.prototype, Document.prototype, DocumentFragment.prototype])



// WEBPACK FOOTER //
// ./themes/default/js/vendor/polyfills.js